import { notification } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { RevenueValues } from './revenue-values';

export function SubscriptionsRevenueRoute(): JSX.Element {
	const [showError, setShowError] = useState<boolean>(false);

	useEffect(() => {
		if (showError === true) {
			notification.error({ message: 'Netværks fejl', onClose: () => setShowError(false) });
		}
	}, [showError]);

	return (
		<Container className="dashboard-container">
			<RevenueValues />
		</Container>
	);
}

const Container = styled.main`
	background-color: #1a202c;
	display: flex;
	
	@media (min-width: 576px) {
		align-items: center;
		justify-content: center;
		
		.revenue-values { margin-top: -80px; }
	}
`;
